export default "__VITE_ASSET__91ab2b71__"